(function () {
  angular
    .module('specsguardApp')
    .directive('sgTableTextFilter', sgTableTextFilter);

  sgTableTextFilter.$inject = [];

  function sgTableTextFilter () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table-text-filter/sg-table-text-filter.html'
    };
  };
})();
